export const API_BASE_URL = 'https://tradeinsights.co.in';
export const API_VERSION = 'v1';
export const API_PREFIX = 'api';
// REACT_APP_CRM_API_BASE_URL points a local build at a local CRM (crm/cmd/salesdev).
export const CRM_API_BASE_URL = process.env.REACT_APP_CRM_API_BASE_URL || 'https://sales.returns.trade';
export const CRM_AUTH_TOKEN = 'dskjhvfgfg46953u0y5y50y90y';

export const buildApiUrl = (endpoint) => `${API_BASE_URL}/${API_VERSION}/${API_PREFIX}/${endpoint}`;
export const buildApiUrl2 = (endpoint) => `https://orca-api.enrichmoney.in/${endpoint}`;
export const buildApiUrl3 = (endpoint) => `https://optionbase.in/v1/api/${endpoint}`;
export const buildCrmApiUrl = (endpoint) => `${CRM_API_BASE_URL}/api/v1/${endpoint}`;

const fetchNumbers = async () => {
  const res = await fetch(buildCrmApiUrl('users/numbers'), {
    headers: { 'Authorization': CRM_AUTH_TOKEN },
  });
  if (!res.ok) return {};
  const json = await res.json();
  return json?.data || json || {};
};

/** Fetches allowed numbers (users + owner_accesses) from CRM. Returns [] on error. */
export const getAllowedNumbers = async () => {
  try {
    const data = await fetchNumbers();
    const users = data.users || [];
    const ownerAccesses = data.owner_accesses || [];
    return [...new Set([...users, ...ownerAccesses])];
  } catch {
    return [];
  }
};

/**
 * Numbers that may log in: the allowed numbers plus the sales dashboard's support users.
 * Support users are kept out of getAllowedNumbers, which also gates the admin page.
 */
export const getLoginNumbers = async () => {
  try {
    const data = await fetchNumbers();
    return [...new Set([...(data.users || []), ...(data.owner_accesses || []), ...(data.support || [])])];
  } catch {
    return [];
  }
};
